import { useState } from "react";
import HttpClient from "../actions/http-client";
import { toast } from "react-toastify";

export const useApiRequest = () => {
    const [loading, setLoading] = useState(false);

    const request = async ({
        method = "GET",
        url,
        body = null,
        config = {},
        onSuccess,
        onError,
        showToast = true,
    }) => {
        setLoading(true);
        // Removed loading toast notification
        const toastId = showToast ? toast.loading("Loading...") : null;
        let response = {};
        try {
            if (method == "GET") response = await new HttpClient().get(url, config);
            else if (method == "POST") response = await new HttpClient().post(url, body, config);
            else if (method == "PUT") response = await new HttpClient().put(url, body, config);
            else if (method == "PATCH") response = await new HttpClient().patch(url, body, config);
            else if (method == "DELETE") response = await new HttpClient().delete(url, body, config);

            // Pass the data to the onSuccess handler
            if (onSuccess) onSuccess(response?.data);
            if (showToast) {
                toast.update(toastId, {
                    render: response?.data?.message || "Success",
                    type: "success",
                    isLoading: false,
                    autoClose: 3000,
                });
            }
        } catch (err) {
            const message = err?.response?.data?.message || err.message || "Something went wrong";

            // Pass the error to the onError handler
            if (onError) onError(err?.response ?? null);
            if (showToast) {
                toast.update(toastId, {
                    render: message,
                    type: "error",
                    isLoading: false,
                    autoClose: 3000,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    return { request, loading };
};